<div class="mobile">
  <div id='header' class="header_mobile">
      <div class="menu-fixed">
          <div class="container header-menu_mobile" *ngIf="!viewModelsBlock">
              <nav class="navbar navbar-expand-lg navbar-light">
                  <a class="navbar-brand" routerLink="">
                      <img src="https://res.cloudinary.com/toyosa-sa/image/upload/v1750857028/production/yamaha/web/assets/mdbrdgarpdu0dwt0skug.svg" alt="Logo Yamaha" class="logo"/>
                  </a>          
                  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation" (click)="viewMenuPrincipal()">
                      <span class="navbar-toggler-icon"></span>
                  </button>
              </nav>
          </div>
          <div class="menu-principal" *ngIf="menuPrincipal">
              <div class="row" >
                  <div class="col-12 menu-principal_items">
                      <div class="row pt-4 pb-4 brand-principal" *ngIf="!search">
                          <a class="col-3 pl-5 navbar-brand_principal" routerLink="">
                              <img src="https://res.cloudinary.com/toyosa-sa/image/upload/v1750857028/production/yamaha/web/assets/mdbrdgarpdu0dwt0skug.svg" alt="Logo Toyota" class="logo ms-4"/>
                          </a> 
                          <div class="col-8">
                              <a class="menu-principal-close" (click)="noViewMenuPrincipal()">
                                <img src="https://res.cloudinary.com/toyosa-sa/image/upload/v1733520961/production/toyota-bolivia/web/assets/icons/header/icono_cerrar.svg" alt="Cerrar" class="icon-menu"/>
                              </a>
                          </div>
                      </div>
                      <div *ngIf="!isMenuOpen('motos') &&  !isMenuOpen('lineafuerza') &&  !isMenuOpen('servicios') && !isMenuOpen('novedades')">
                        <ul class="menu-principal_items-menu">
                            <li class="my-4" *ngIf="userJson">
                                <a class="d-block bg-dark text-white w-50 py-2 text-center m-auto rounded-4 fs-5" routerLink="/usuario/perfil" (click)="noViewMenuPrincipal()">Tu Perfil <img class="ms-1" [src]="imguserlogin" width="23"/></a>                    
                            </li>
                            <li class="" >
                                <a (click)="abrirSubMenu('motos')">
                                    Motos
                                    <img class="navbar-icono" [src]="getMenuIcon('motos')"/>
                                </a>
                            </li>
                            <li class="" >
                                <a (click)="abrirSubMenu('lineafuerza')">
                                    Línea de fuerza
                                    <img class="navbar-icono" [src]="getMenuIcon('lineafuerza')"/>
                                </a>
                            </li>
                            <li class="" >
                                <a (click)="abrirSubMenu('servicios')">
                                    Servicios
                                    <img class="navbar-icono" [src]="getMenuIcon('servicios')"/>
                                </a>
                            </li>
                            <li class="" >
                                <a (click)="abrirSubMenu('novedades')">
                                    Novedades
                                    <img class="navbar-icono" [src]="getMenuIcon('novedades')"/>
                                </a>
                            </li>
                            <li class="nav-link" (click)="noViewMenuPrincipal()">
                                <a routerLink="/sucursales">Sucursales</a>
                            </li>
                            <!--<li class="nav-link" (click)="noViewMenuPrincipal()">
                                <a routerLink="/contactenos">Contacto</a>
                            </li>-->
                            <hr *ngIf="!userJson">
                            <li class="nav-link" (click)="noViewMenuPrincipal()" *ngIf="!userJson">
                                <a routerLink="/registro">Registro</a>
                            </li>
                            <li class="nav-link" (click)="noViewMenuPrincipal()" *ngIf="!userJson">
                                <a routerLink="/login">Login</a>
                            </li>
                            
                        </ul>
                      </div>
                    <div class="submenu row" *ngIf="isMenuOpen('motos')" >
                        <div class="row bg-gray py-2 px-4">
                            <div class="col-12 ff-light fw-semibold" (click)="backModels()"> <span class="me-1 ff-medium"><</span> Volver a la página anterior</div>
                        </div>
                        <div class="submenu-component-actived">
                            <app-mobile-modelos categoria="motos"></app-mobile-modelos>
                        </div>
                    </div>
                    <div class="submenu row" *ngIf="isMenuOpen('lineafuerza')" >
                        <div class="row bg-gray py-2 px-4">
                            <div class="col-12 ff-light fw-semibold" (click)="backModels()"> <span class="me-1 ff-medium"><</span> Volver a la página anterior</div>
                        </div>
                        <div class="submenu-component-actived">
                            <app-mobile-modelos categoria="linea-de-fuerza"></app-mobile-modelos>
                        </div>
                    </div>
                    <div class="submenu row" *ngIf="isMenuOpen('servicios')"  (mouseleave)="cerrarSubMenu('servicios')">
                        <div class="row bg-gray py-2 px-4">
                            <div class="col-12 ff-light fw-semibold" (click)="backModels()"> <span class="me-1 ff-medium"><</span> Volver a la página anterior</div>
                        </div>
                        <div class="submenu-component-actived">
                            <app-mobile-servicios></app-mobile-servicios>
                        </div>
                    </div>
                    <div class="submenu row" *ngIf="isMenuOpen('novedades')"  (mouseleave)="cerrarSubMenu('novedades')">
                        <div class="row bg-gray py-2 px-4">
                            <div class="col-12 ff-light fw-semibold" (click)="backModels()"> <span class="me-1 ff-medium"><</span> Volver a la página anterior</div>
                        </div>
                        <div class="submenu-component-actived">
                            <app-mobile-novedades></app-mobile-novedades>
                        </div>
                    </div>
                  </div>
              </div>  
              
              
          </div>
          
      </div>
  </div>    
</div>